<template>
    <div id="activity" class="maincont child system-diagram-setting">
        <div class="ef--inner2">
            <div class="page-title">
                <h2>系統図メンテナンス</h2>
            </div>
            <div class="filter">
                <div class="filter-condition account-list-filter-condition">
                    <ul>
                        <li class="filter-condition-list-item">
                            <label class="text-start">系統図</label>
                        </li>
                        <li class="filter-condition-list-item">
                            <label>区分：</label>
                            <span class="select-box">
                                <select class="form-select"
                                    name ="division"
                                    v-model="systemDiagram.division"
                                    data-vv-as="区分"
                                    v-validate="'excluded:0|required'" 
                                    data-vv-scope="system_diagram_info">
                                    <option 
                                        v-for="(option, index) in systemDiagramInfoDivisionList" 
                                        v-bind:value="option"
                                        v-bind:key="index" >{{ option }}</option>
                                </select>
                            </span>
                            <div class="err_message">{{ errors.first("system_diagram_info.division") }}</div>
                        </li>
                        <li class="filter-condition-list-item">
                            <label>名称：</label>
                            <input
                                type="text" 
                                class="input-field" 
                                v-model="systemDiagram.name"
                                name="name" 
                                data-vv-as="系統図名称" 
                                v-validate="'required|max:64'"
                                data-vv-scope="system_diagram_info"
                            />
                            <div class="err_message">{{ errors.first("system_diagram_info.name") }}</div>
                        </li>
                        <li>
                            <ul class="filter-condition-list">
                                <li class="filter-condition-list-item">
                                    <label>ファイル名：</label>
                                    <input 
                                        class="input-field" 
                                        v-model="systemDiagram.fileName" 
                                        readonly
                                        name="file_diagram" 
                                        data-vv-as="ファイル名" 
                                        v-validate="'required'"
                                        data-vv-scope="system_diagram_info"
                                        />
                                    <div class="err_message">{{ errors.first("system_diagram_info.file_diagram") }}</div>
                                    <div class="err_message">{{ errors.first("system_diagram_info.select_file_diagram") }}</div>
                                </li>
                                <li class="filter-condition-list-item"><a href="javascript:void(0);" @click="onChooseFileDiagramOnS3" class="bt-cyan">ファイル選択</a></li>
                                <li class="filter-condition-list-item">
                                    <a href="javascript:void(0);" class="bt-cyan" @click="onChooseFileDiagramFromLocal">ファイル登録</a>
                                    <input 
                                        type="file" 
                                        class="hide" 
                                        ref="refFileDiagram" 
                                        name="select_file_diagram" 
                                        data-vv-as="系統図画像ファイル" 
                                        v-validate="'ext:svg,png,jpeg,jpg'"
                                        data-vv-scope="system_diagram_info"
                                        @change="onRegisterDiagramFromLocal" />
                                </li>
                                <li class="filter-condition-list-item"><a href="javascript:void(0);" class="bt-cyan" @click="onShowSelectionDiagram">系統図変更</a></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="d-flex justify-content-between control-items">
                        <li>
                            <pagination
                                :maxRecord="totalRecord"
                                :totalPages="totalPages"
                                :currentPage="currentPage"
                                @pagechanged="onPageChange">
                            </pagination>
                        </li>
                        <li>
                            <ul class="d-flex button-csv">
                                <li class="button-item">
                                    <a href="javascript:void(0);" class="bt-csv" @click="onChooseImportFile">CSV取り込み</a>
                                    <input
                                        type="file" 
                                        class="hide" 
                                        ref="refImportFile"
                                        name="import_file" 
                                        data-vv-as="ファイル選択" 
                                        v-validate="'ext:csv'"
                                        data-vv-scope="system_diagram_info"
                                        @change="onImportCSV" />
                                    <div class="err_message"> {{ errors.first("import_file") }}</div>
                                </li>
                                <li class="button-item"><a href="javascript:void(0);" class="bt-csv" @click="onExportCSV">CSVダウンロード</a></li>
                            </ul>
                        </li>
                        <li>
                            <ul class="d-flex">
                                <li><a href="javascript:void(0);" class="bt-cyan" @click="onRegister">保存</a></li>
                            </ul>
                        </li>
                    </ul>
                    
                </div>
            </div>

            <ValidationObserver ref="tableObserver">
            <div class="scroll" style="height: 580px;">
                <table class="normal-table" id="maintenance-table">
                <thead>
                    <tr>
                    <th rowspan="2" class="d-mw-30">No.</th>
                    <th rowspan="2" class="d-mw-200">要素名</th>
                    <th rowspan="2" style="min-width: 120px">区分</th>
                    <th rowspan="2" style="min-width: 120px">データ</th>
                    <th colspan="6" style="min-width: 455px">アイコン設定</th>
                    <th colspan="4" style="min-width: 385px">テキスト設定</th>
                    <th colspan="3">表示位置</th>
                    </tr>
                    <tr class="thead-sub">
                    <th style="min-width: 120px;">画像(ON)</th>
                    <th>縦<br>サイズ</th>
                    <th>横<br>サイズ</th>
                    <th style="min-width: 120px;">画像(OFF)</th>
                    <th>縦<br>サイズ</th>
                    <th>横<br>サイズ</th>
                    <th>テキスト</th>
                    <th>フォント<br>サイズ</th>
                    <th >フォント<br>色</th>
                    <th style="min-width: 100px">フォント<br>スタイル</th>
                    <th>X軸座標<br>→</th>
                    <th>Y軸座標<br>↓</th>
                    <th class="border-right">レイヤー</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in displaySystemDiagram" v-bind:key="index">
                        <td>{{ item.no }}</td>
                        <td>
                            <ValidationProvider
                                :rules="( item.item_status === 1) ?'required|max:64' : 'max:64'"
                                v-slot="{ errors }"
                                name="要素名"
                            >
                                <input 
                                type="text" 
                                class="cell-input-field text-left" 
                                v-model="item.name" 
                                maxlength="65" />
                                <div class="err_message">{{ errors[0] }}</div>
                            </ValidationProvider>
                            <div :class="{'disable-cell': item.item_status === 0}"></div>
                        </td>
                        <td>
                            <span class="select-box">
                                <select 
                                    v-model="item.division_id" 
                                    @change="onChangeDivision($event, index)"
                                    :name="'division_' + pageAndIndex(index)"
                                    data-vv-as="区分"
                                    v-validate="(item.division_status === 1) ? 'required' : ''" 
                                    >
                                    <option 
                                        v-for="(option, index) in systemDiagramDivisionList" 
                                        v-bind:value="option.id"
                                        v-bind:key="index">{{ option.name_ja }}</option>
                                </select>
                            </span>
                            <div class="err_message">{{ errors.first('division_' + pageAndIndex(index)) }}</div>
                            <div :class="{'disable-cell': item.division_status === 0}"></div>
                        </td>
                        <td>
                            <span class="select-box">
                                <select 
                                    v-model="item.data_id"
                                    :name="'data_id_' + pageAndIndex(index)"
                                    data-vv-as="データ"
                                    v-validate="( item.data_status === 1) ? 'required' : ''" 
                                    v-if="item.division_id == 1">
                                    <option 
                                        v-for="(option, index) in binaryIconList" 
                                        v-bind:value="option.id"
                                        v-bind:key="'binary_icon_' + pageAndIndex(index)">{{ option.data_code }}</option>
                                </select>
                                <select 
                                    v-model="item.data_id"
                                    :name="'data_id_' + pageAndIndex(index)"
                                    data-vv-as="データ"
                                    v-validate="( item.data_status === 1) ? 'required' : ''" 
                                    v-if="item.division_id == 3">
                                    <option
                                        v-for="(option, index) in numericalList" 
                                        v-bind:value="option.id"
                                        v-bind:key="'numerical_' + pageAndIndex(index)">{{ option.data_code }}</option>
                                </select>
                            </span>
                            <div class="err_message">{{ errors.first('data_id_' + pageAndIndex(index)) }}</div>
                            <div :class="{'disable-cell': item.data_status === 0}"></div>
                        </td>
                        <td>
                            <span class="select-box">
                                <select 
                                    v-model="item.on_icon"
                                    :name="'on_icon_' + pageAndIndex(index)"
                                    data-vv-as="画像(ON)"
                                    v-validate="( item.on_icon_status === 1) ? 'required' : ''" >
                                    <option 
                                        v-for="(option, index) in iconList" 
                                        v-bind:value="option"
                                        v-bind:key="index">{{ option }}</option>
                                </select>
                            </span>
                            <div class="err_message">{{ errors.first('on_icon_' + pageAndIndex(index)) }}</div>
                            <div :class="{'disable-cell': item.on_icon_status === 0}"></div>
                        </td>
                        <td>
                            <ValidationProvider
                                :rules="( item.on_icon_x_status === 1) ?'required|min_value:0|max_value:999' : 'min_value:0|max_value:999'"
                                v-slot="{ errors }"
                                name="縦サイズ"
                            >
                                <input type="number" 
                                class="input-field" 
                                v-model="item.on_icon_x" />
                                <div class="err_message">{{ errors[0] }}</div>
                            </ValidationProvider>

                            <div :class="{'disable-cell': item.on_icon_x_status === 0}"></div>
                        </td>
                        <td>
                            <ValidationProvider
                                :rules="( item.on_icon_y === 1) ? 'required|min_value:0|max_value:999' : 'min_value:0|max_value:999'"
                                v-slot="{ errors }"
                                name="横サイズ"
                            >
                                <input type="number" 
                                class="input-field" 
                                v-model="item.on_icon_y" />
                                <div class="err_message">{{ errors[0] }}</div>
                            </ValidationProvider>

                            <div :class="{'disable-cell': item.on_icon_y_status === 0}"></div>
                        </td>
                        <td>
                            <span class="select-box">
                                <select 
                                    v-model="item.off_icon"
                                    :name="'off_icon_' + pageAndIndex(index)"
                                    data-vv-as="画像(OFF"
                                    
                                    v-validate="( item.off_icon_status === 1) ? 'required' : ''">
                                    <option 
                                        v-for="(option, index) in iconList" 
                                        v-bind:value="option"
                                        v-bind:key="index" >{{ option }}</option>
                                </select>
                            </span>
                            <div class="err_message">{{ errors.first('off_icon_' + pageAndIndex(index)) }}</div>
                            <div :class="{'disable-cell': item.off_icon_status === 0}"></div>
                        </td>
                        <td>
                            <ValidationProvider
                                :rules="( item.item_status === 1) ?'required|min_value:0|max_value:999' : 'min_value:0|max_value:999'"
                                v-slot="{ errors }"
                                name="縦サイズ"
                            >
                                <input type="number" 
                                class="input-field" 
                                v-model="item.off_icon_x" />
                                <div class="err_message">{{ errors[0] }}</div>
                            </ValidationProvider>

                            <div :class="{'disable-cell': item.off_icon_y_status === 0}"></div>
                        </td>
                        <td>
                            <ValidationProvider
                                :rules="( item.off_icon_y_status === 1) ?'required|min_value:0|max_value:999' : 'min_value:0|max_value:999'"
                                v-slot="{ errors }"
                                name="横サイズ"
                            >
                                <input type="number" 
                                class="input-field" 
                                v-model="item.off_icon_y" />
                                <div class="err_message">{{ errors[0] }}</div>
                            </ValidationProvider>
                            <div :class="{'disable-cell': item.off_icon_y_status === 0}"></div>
                        </td>
                        <td>
                            <ValidationProvider
                                :rules="( item.text_status === 1) ? 'required|max:30' : 'max:30'"
                                v-slot="{ errors }"
                                name="テキスト"
                            >
                                <input 
                                    type="text" 
                                    class="cell-input-field text-left" 
                                    v-model="item.text"
                                    maxlength="31" />
                                <div class="err_message">{{ errors[0] }}</div>
                            </ValidationProvider>
                            <div :class="{'disable-cell': item.text_status === 0}"></div>
                        </td>
                        <td>
                            <span class="select-box">
                                <select 
                                    v-model="item.font_size"
                                    :name="'font_size_' + pageAndIndex(index)"
                                    data-vv-as="フォントサイズ"
                                    
                                    v-validate="( item.font_size_status === 1) ? 'required' : ''">
                                    <option 
                                        v-for="(option, index) in fontSizeList" 
                                        v-bind:value="option"
                                        v-bind:key="index" >{{ option }}</option>
                                </select>
                            </span>
                            <div class="err_message">{{ errors.first('font_size_' + pageAndIndex(index)) }}</div>
                            <div :class="{'disable-cell': item.font_size_status === 0}"></div>
                        </td>
                        <td>
                            <span class="select-box">
                                <select 
                                    v-model="item.font_color"
                                    :name="'font_color_' + pageAndIndex(index)"
                                    data-vv-as="フォント色"
                                    v-validate="(item.font_color_status === 1) ? 'required' : ''">
                                    <option 
                                        v-for="(option, index) in fontColorList" 
                                        v-bind:value="option.value"
                                        v-bind:key="index" >{{ option.name.name }}</option>
                                </select>
                            </span>
                            <div class="err_message">{{ errors.first('font_color_' + pageAndIndex(index)) }}</div>
                            <div :class="{'disable-cell': item.font_color_status === 0}"></div>
                        </td>
                        <td>
                            <span class="select-box">
                                <select 
                                    v-model="item.font_style"
                                    :name="'font_style_' + pageAndIndex(index)"
                                    data-vv-as="フォントスタイル"
                                    v-validate="(item.font_style_status === 1) ? 'required' : ''">
                                    <option 
                                        v-for="(option, index) in fontStyleList" 
                                        v-bind:value="option.value"
                                        v-bind:key="index" >{{ option.name.name }}</option>
                                </select>
                            </span>
                            <div class="err_message">{{ errors.first('font_style_' + pageAndIndex(index)) }}</div>
                            <div :class="{'disable-cell': item.font_style_status === 0}"></div>
                        </td>
                        <td>
                            <ValidationProvider
                                :rules="(item.coordinate_status === 1) ? 'required|min_value:0|max_value:1920' : 'min_value:0|max_value:1920'"
                                v-slot="{ errors }"
                                name="X軸座標"
                            >
                                <input 
                                    type="number" 
                                    class="input-field" 
                                    v-model="item.axis_x" />
                                <div class="err_message">{{ errors[0] }}</div>
                            </ValidationProvider>
                            <div :class="{'disable-cell': item.coordinate_status === 0}"></div>
                        </td>
                        <td>
                            <ValidationProvider
                                :rules="(item.coordinate_status === 1) ? 'required|min_value:0|max_value:1080' : 'min_value:0|max_value:1080'"
                                v-slot="{ errors }"
                                name="Y軸座標"
                            >
                                <input 
                                    type="number" 
                                    class="input-field"
                                    v-model="item.axis_y" />
                                <div class="err_message">{{ errors[0] }}</div>
                            </ValidationProvider>

                            <div :class="{'disable-cell': item.coordinate_status === 0}"></div>
                        </td>
                        <td>
                            <span class="select-box">
                                <select v-model="item.layer">
                                    <option 
                                        v-for="(option, index) in layerList" 
                                        v-bind:value="option"
                                        v-bind:key="index" >{{ option }}</option>
                                </select>
                            </span>
                            <div :class="{'disable-cell': item.layer_status === 0}"></div>
                        </td>
                    </tr>
                </tbody>
                </table>
            </div>
            </ValidationObserver>
        </div>
        <system-diagram-selection-dialog
            @close="showSelectModal = false"
            v-if="showSelectModal"
            :systemDiagramInfoList="systemDiagramInfoList"
            @onSelectDiagram="onSelectDiagram"
            @onShowRegisterDiagram="onShowRegisterDiagram"
        ></system-diagram-selection-dialog>
        <system-diagram-register-dialog
            @close="showRegisterModal = false"
            v-if="showRegisterModal"
            @getDiagramName="getDiagramName"
            @onShowSelectionDiagram="onCloseRegisterDiagram"
        ></system-diagram-register-dialog>
        <system-diagram-selection-file-s3-dialog
            @close="showSelectFileS3Modal = false"
            v-if="showSelectFileS3Modal"
            @onSelectFileS3="onSelectFileS3"
        ></system-diagram-selection-file-s3-dialog>
    </div>
</template>
<script>
/* eslint-disable */
import Pagination from "../../components/Pagination";
import SystemDiagramSelectionDialog from "../../components/SystemDiagramSelectionDialog";
import SystemDiagramRegisterDialog from "../../components/SystemDiagramRegisterDialog";
import SystemDiagramSelectionFileS3Dialog from "../../components/SystemDiagramSelectionFileS3Dialog";
import Utils from "../../utils/utils";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
    name: "SystemDiagramSetting",
    components: {
        SystemDiagramSelectionDialog,
        SystemDiagramRegisterDialog,
        SystemDiagramSelectionFileS3Dialog,
        Pagination,
        ValidationProvider,
        ValidationObserver
    },
    data: function() {
        return {
            accountId: '',
            clusterId: 0,
            areaId: 0,
            systemType: '',
            showSelectModal: false,
            showRegisterModal: false,
            showSelectFileS3Modal: false,
            systemDiagram: {
                id: 0,
                division: '',
                name: '',
                fileName: ''
            },
            iconList: [],
            binaryIconList: [],
            numericalList: [],
            fontSizeList: Utils.getFontSizeList(),
            fontColorList: Utils.getFontColorList(),
            fontStyleList: Utils.getFontStyleList(),
            layerList: Utils.getLayerList(),
            systemDiagramDivision: new Map(),
            systemDiagramDataList: [],
            systemDiagramDivisionList: [],
            systemDiagramInfoList: [],
            systemDiagramInfoDivisionList: Utils.getSystemDiagramInfoDivisionList(),
            systemDiagramSettingsList: [],
            totalPages: 1,
            currentPage: 1,
            perPage: 30,
            totalRecord: 0,
        }
    },
    computed: {
        displaySystemDiagram() {
            if (!this.systemDiagramSettingsList || this.systemDiagramSettingsList.length == 0) {
                this.systemDiagramSettingsList = this.dumpData()
            }
            return this.paginate(this.systemDiagramSettingsList);
        }
    },
    mounted: function() {
        this.accountId = this.$route.params.id
        console.log("SystemDiagramSetting: mounted with account : %o%o", this.accountId);

        this.getClusterIdAndAreaId()
    },
    methods: {
        getClusterIdAndAreaId: function() {
            const params = new URLSearchParams();
            params.append("account", this.accountId);

            const request = {
                params: params,
                withCredentials: true
            };

            this.$axios
            .get(`/srv/api/account_master_es/cluster_id_and_area_id`, request)
            .then(response => {
                console.log("[GET][api/account_master_es/cluster_id_and_area_id] : OK");
                if (typeof response.data == "object") {
                    this.areaId = response.data.area_id;
                    this.clusterId = response.data.cluster_id;
                    this.systemType = response.data.system_type;

                    // system diagram division
                    this.getSystemDiagramInfoList()

                    // load master data
                    this.getIconList()
                    this.getBinaryIconList()
                    this.getNumericalList()
                    this.getSystemDiagramDivisionList()
                } else {
                    // stringのときはセッションタイムアウト
                    alert("sesssion time out");
                    this.$store.dispatch("logout");
                    this.$router.push("/login");
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
        onSelectDiagram: function(pSystemDiagramId) {
            this.systemDiagram.id = pSystemDiagramId
            this.resetPage()
            this.loadData()
        },
        onCloseRegisterDiagram: function() {
            if (this.systemDiagramInfoList && this.systemDiagramInfoList.length > 0) {
                this.getSystemDiagramInfoList()
            } else {
                this.showRegisterModal = false
                this.showSelectModal = false
            }
        },
        onShowSelectionDiagram: function() {
            this.getSystemDiagramInfoList()
        },
        onShowRegisterDiagram: function() {
            this.showSelectModal = false
            this.showRegisterModal = true
        },
        getDiagramName: function(diagramName) {
            this.systemDiagram.id = 0
            this.systemDiagram.division = ''
            this.systemDiagram.name = diagramName
            this.systemDiagram.fileName = ''
            // reset data
            this.systemDiagramSettingsList = []

            this.showSelectModal = false
            this.showRegisterModal = false
        },
        onSelectFileS3: function(fileName) {
            if (!(this.clusterId && this.areaId)) {
                return
            }
            this.showSelectFileS3Modal = false
            this.systemDiagram.fileName = fileName

            this.$validator.validateAll('system_diagram_info').then(valid => {
                if (valid) {
                    const params = {
                        'id': this.systemDiagram.id,
                        'name': this.systemDiagram.name,
                        'division': this.systemDiagram.division,
                        'file_name': this.systemDiagram.fileName,
                        'cluster_id': this.clusterId,
                        'area_id': this.areaId
                    };

                    this.$axios
                    .post(`/srv/api/system_diagram_setting`, params, {
                        withCredentials: true,
                    })
                    .then(response => {
                        const data = response.data;
                        if (data.status !== undefined) {
                            if (data.status === "success") {
                                console.log("[POST][system_diagram_setting]: OK");
                                this.systemDiagram.id = data.id
                                alert("登録が完了しました。");
                            } else if (data.status === "duplicate") {
                                console.log("[POST][system_diagram_setting]: error " + data.status);
                                alert("「系統図名称」がシステムに既に存在している。");
                                this.systemDiagram.fileName = ''
                            } else {
                                console.log("[POST][system_diagram_setting]: error " + data.status);
                                alert("登録できませんでした");
                                this.systemDiagram.fileName = ''
                            }
                        } else {
                            console.log("[POST][system_diagram_setting]: error");
                            alert("登録できませんでした");
                            this.systemDiagram.fileName = ''
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
                }
            })
        },
        onChooseFileDiagramOnS3() {            
            this.showSelectFileS3Modal = true
            this.$refs.refFileDiagram.value = ''
        },
        onChooseFileDiagramFromLocal() {
            this.$refs.refFileDiagram.click()
        },
        onRegisterDiagramFromLocal: function() {
            if (!(this.clusterId && this.areaId)) {
                return
            }
            let fileData = this.$refs.refFileDiagram.files[0]
            let fileName = this.systemDiagram.fileName

            this.systemDiagram.fileName = fileData.name

            this.$validator.validateAll('system_diagram_info').then(valid => {
                if (valid) {
                    const formData = new FormData();
                    formData.append("id", this.systemDiagram.id);
                    formData.append("name", this.systemDiagram.name);
                    formData.append("division", this.systemDiagram.division);
                    formData.append("file", fileData); 
                    formData.append("clusterId", this.clusterId); 
                    formData.append("areaId", this.areaId); 

                    console.log("[POST] [Register system_diagram_setting from select file local]");
                    this.$axios
                    .post(`/srv/api/system_diagram_setting/s3`, formData, {
                        withCredentials: true,
                    })
                    .then(response => {
                        const data = response.data;
                        if (data.status !== undefined) {
                            if (data.status === "success") {
                                console.log("[POST][system_diagram_setting/s3]: OK");
                                this.systemDiagram.id = data.id
                                alert("登録が完了しました。");
                            } else if (data.status === "duplicate") {
                                console.log("[POST][system_diagram_setting]: error " + data.status);
                                alert("「系統図名称」がシステムに既に存在している。");
                                this.systemDiagram.fileName = ''
                            }  else {
                                console.log("[POST][system_diagram_setting/s3]: error " + data.status);
                                alert("登録できませんでした");
                                this.systemDiagram.fileName = ''
                            }
                        } else {
                            console.log("[POST][system_diagram_setting/s3]: error");
                            alert("登録できませんでした");
                            this.systemDiagram.fileName = ''
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
                    // reset file
                    this.$refs.refFileDiagram.value = ''
                } else {
                    this.systemDiagram.fileName = fileName
                }
            })
        },
        onPageChange: function(page) {
            this.currentPage = page;
            this.errors.clear()
            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        onChooseImportFile: function() {
            this.$refs.refImportFile.click()
        },
        resetPage: function() {
            this.totalRecord = 0
            this.systemDiagramSettingsList = []
            this.onPageChange(1)
        },
        onImportCSV: function () {
            const fileinput = this.$refs.refImportFile.files[0]
            if (fileinput['type'] !== 'text/csv') {
                alert('拡張子が「CSV」のファイルを選択してください。')
                return
            }
            this.resetPage()
 
            const reader = new FileReader()
            const headerForTable =
            {
                'No.' : 'no',
                '設定ID' : 'id',
                '要素名' : 'name',
                '区分ID' : 'division_id',
                '区分名' : 'division_name',
                'データ' : 'data_id',
                '画像(ON)' : 'on_icon',
                '画像(ON)縦サイズ' : 'on_icon_x',
                '画像(ON)横サイズ' : 'on_icon_y',
                '画像(OFF)' : 'off_icon',
                '画像(OFF)縦サイズ' : 'on_icon_x',
                '画像(OFF)横サイズ' : 'on_icon_y',
                'テキスト' : 'text',
                'フォントサイズ' : 'font_size',
                'フォント色' : 'font_color',
                'フォントスタイル' : 'font_style',
                'X軸座標' : 'axis_x',
                'Y軸座標' : 'axis_y',
                'レイヤー' : 'layer'
            }
            reader.onload = function (e) {
                let text = e.target.result
                text = text.replaceAll('\r','')
                const delimiter = ","
                const lineBreak = "\n"

                const headerCsv = text.slice(0, text.indexOf(lineBreak)).split(delimiter)
                const rows = text.slice(text.indexOf(lineBreak) + 1).split(lineBreak)

                let arr = []
                let no = 1
                rows.forEach(row => {
                    const values = row.split(delimiter)
                    let object = {}
                    for(let index = 0; index < headerCsv.length; index++) {
                        let header = headerForTable[headerCsv[index]]
                        if (!header) {
                            continue
                        }
                        switch(header) {
                            case 'division_id':
                                object[header] = Number(values[index]) || 0
                                break
                            case 'font_size':
                                object[header] = Number(values[index]) || 10
                                break
                            case 'font_color':
                                object[header] = Number(values[index]) || 1
                                break
                            case 'font_style':
                                object[header] = Number(values[index]) || 0
                                break
                            case 'axis_x':
                                object[header] = Number(values[index]) || 0
                                break
                            case 'axis_y':
                                object[header] = Number(values[index]) || 0
                                break
                            case 'layer':
                                object[header] = Number(values[index]) || 1
                                break
                            default:
                                object[header] = values[index] || ''
                        }
                    }
                    object['no'] = no++
                    let divi = {}
                    if (object['division_id'] || object['division_id'] === 0) {
                        divi = this.systemDiagramDivision.get(parseInt(object['division_id']))
                    }

                    object = this.additionalSystemDiagramDivisionForObject(object, divi)
                    arr.push(object)
                })

                this.systemDiagramSettingsList = arr
                this.totalRecord = this.systemDiagramSettingsList.length
                // reset file
                this.$refs.refImportFile.value = ''
            }.bind(this);
            
            reader.readAsText(fileinput)    
        },
        onExportCSV: function() {
            const dataList = this.systemDiagramSettingsList
            const prefixFilename = 'kyuden_system_diagram_setting_'
            const header =
            {
                'no' : 'No.',
                'id' : '設定ID',
                'name' : '要素名',
                'division_id' : '区分ID',
                'division_name' : '区分名',
                'data_id' : 'データ',
                'on_icon' : '画像(ON)',
                'on_icon_x' : '画像(ON)縦サイズ',
                'on_icon_y' : '画像(ON)横サイズ',
                'off_icon' : '画像(OFF)',
                'on_icon_x' : '画像(OFF)縦サイズ',
                'on_icon_y' : '画像(OFF)横サイズ',
                'text' : 'テキスト',
                'font_size' : 'フォントサイズ',
                'font_color' : 'フォント色',
                'font_style' : 'フォントスタイル',
                'axis_x' : 'X軸座標',
                'axis_y' : 'Y軸座標',
                'layer' : 'レイヤー'
            }

            let keyHeader = Object.keys(header)
            let resp = []
            let no = 1
            dataList.forEach(data => {
                let rowData = []
                keyHeader.forEach(key => {
                    switch(key) {
                        case 'no':
                            rowData.push(no++)
                            break
                        case 'division_id':
                            rowData.push(data[key] || 0)
                            break
                        case 'division_name':
                            let divisionId = data['division_id'] || 0
                            let divi = this.systemDiagramDivision.get(divisionId)
                            rowData.push(divi.name_ja)
                            break
                        case 'font_size':
                            rowData.push(data[key] || 10)
                            break
                        case 'font_color':
                            rowData.push(data[key] || 1)
                            break
                        case 'font_style':
                            rowData.push(data[key] || 0)
                            break
                        case 'axis_x':
                            rowData.push(data[key] || 0)
                            break
                        case 'axis_y':
                            rowData.push(data[key] || 0)
                            break
                        case 'layer':
                            rowData.push(data[key] || 1)
                            break
                        default:
                            rowData.push(data[key] || '')
                    }
                })
                resp.push(rowData)
            })

            Utils.exportData(resp, prefixFilename, header)
        },
        async onRegister() {
            const isTableValid = await this.$refs.tableObserver.validate();
            this.$validator.validateAll().then(system_diagram_info_valid => {
                if (system_diagram_info_valid && isTableValid && this.systemDiagram.id) {
                    const ans = confirm('保存しますか？')
                    if (ans) {
                        this.$store.dispatch("setLoading", true)
                        const param = {
                            'system_diagram_id': this.systemDiagram.id,
                            'system_diagram_settings': this.systemDiagramSettingsList
                        };
                        this.$axios
                        .post(`/srv/api/system_diagram_setting/settings`, param, {
                            withCredentials: true,
                        })
                        .then(response => {
                            this.$store.dispatch("setLoading", false)
                            const data = response.data;
                            if (data.status !== undefined) {
                                if (data.status === "success") {
                                    console.log("[POST][system_diagram_setting/settings]:OK");
                                    alert("登録が完了しました。");
                                    this.loadData()
                                } else {
                                    console.log("[POST][system_diagram_setting/settings]: error");
                                    alert("登録できませんでした");
                                }
                            } else {
                                console.log("[POST][system_diagram_setting/settings]: error");
                                alert("登録できませんでした");
                            }
                        })
                        .catch(error => {
                            this.$store.dispatch("setLoading", false)
                            console.log("[POST][system_diagram_setting/settings]: error");
                            alert("登録できませんでした");
                        }); 
                    }
                }
            })
            
            
        },
        loadData: function() {
            const params = new URLSearchParams();
            params.append("cluster_id", this.clusterId);
            params.append("area_id", this.areaId);

            const request = {
                params: params,
                withCredentials: true
            };

            this.$axios
            .get(`/srv/api/system_diagram_setting/${this.systemDiagram.id}`, request)
            .then(response => {
                console.log("[GET][system_diagram_setting/{system_diagram_id}]:OK");
                if (typeof response.data == "object") {

                    this.systemDiagram.division = response.data.division
                    this.systemDiagram.name = response.data.name
                    this.systemDiagram.fileName = response.data.file_name

                    this.showSelectModal = false
                    this.showRegisterModal = false
                    this.getSystemDiagramSettingsList()
                } else {
                    // string のときはセッションタイムアウト
                    alert("sesssion time out");
                    this.$store.dispatch("logout");
                    this.$router.push("/login");
                }
            })
            .catch(error => {
                console.log("[GET][system_diagram_setting/{system_diagram_id}]:error");
                console.log(error);
            });
        },
        paginate (systemDiagramSettingsList) {
            if (!systemDiagramSettingsList) return

            let dataLength = systemDiagramSettingsList.length
            if (dataLength == 0) {
                dataLength = 1
            }
            this.totalPages = Math.ceil(dataLength / this.perPage)
            let page = this.currentPage;
			let perPage = this.perPage;
			let from = (page * perPage) - perPage;
			let to = (page * perPage);
			return systemDiagramSettingsList.slice(from, to);
        },
        getIconList: function() {
            const params = new URLSearchParams();
            params.append("cluster_id", this.clusterId);
            params.append("area_id", this.areaId);

            const request = {
                params: params,
                withCredentials: true
            };

            this.$axios
            .get(`/srv/api/system_diagram_setting/icons`, request)
            .then(response => {
                console.log("[GET][system_diagram_setting/icons] : OK");
                if (typeof response.data == "object") {
                    this.iconList = response.data.system_diagram_icons;
                } else {
                    // stringのときはセッションタイムアウト
                    alert("sesssion time out");
                    this.$store.dispatch("logout");
                    this.$router.push("/login");
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
        getBinaryIconList : function() {
            const params = new URLSearchParams();
            params.append("cluster_id", this.clusterId);
            params.append("area_id", this.areaId);

            const request = {
                params: params,
                withCredentials: true
            };

            this.$axios
            .get(`/srv/api/system_diagram_setting/data/binary_icon`, request)
            .then(response => {
                if (typeof response.data == "object") {
                    console.log("[GET][system_diagram_setting/data/binary_icon]:OK");
                    this.binaryIconList = response.data.binary_icon; 
                } else {
                    // stringのときはセッションタイムアウト
                    alert("sesssion time out");
                    this.$store.dispatch("logout");
                    this.$router.push("/login");
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
        getNumericalList : function() {
            const params = new URLSearchParams();
            params.append("cluster_id", this.clusterId);
            params.append("area_id", this.areaId);

            const request = {
                params: params,
                withCredentials: true
            };

            this.$axios
            .get(`/srv/api/system_diagram_setting/data/numerical`, request)
            .then(response => {
                console.log("[GET][system_diagram_setting/data/numerical]: OK");
                if (typeof response.data == "object") {
                    this.numericalList = response.data.numerical; 
                } else {
                    // stringのときはセッションタイムアウト
                    alert("sesssion time out");
                    this.$store.dispatch("logout");
                    this.$router.push("/login");
                }
            })
            .catch(error => {
                console.log("[GET][system_diagram_setting/data/numerical] error");
                console.log(error);
            });
        },
        getSystemDiagramDivisionList: function() {
            this.$axios
            .get(`/srv/api/system_diagram_setting/division`, {
                withCredentials: true
            })
            .then(response => {
                if (typeof response.data == "object") {
                    console.log("[GET][system_diagram_setting/division]: OK");
                    let respData = response.data.system_diagram_division
                    this.systemDiagramDivisionList = []
                    this.systemDiagramDivision = new Map()

                    respData.forEach(divi => {
                        if ('PPA' === this.systemType && divi.name === 'binary_icon') {
                            return
                        }

                        divi['name_ja'] = Utils.getDivisionNameJP(divi.name.trim())

                        this.systemDiagramDivisionList.push(divi)
                        this.systemDiagramDivision.set(divi.id, divi)
                    })
                } else {
                    // stringのときはセッションタイムアウト
                    alert("sesssion time out");
                    this.$store.dispatch("logout");
                    this.$router.push("/login");
                }
            })
            .catch(error => {
                console.log("[GET][system_diagram_setting/division]: error");
                console.log(error);
            });
        },
        getSystemDiagramInfoList: function() {
            const params = new URLSearchParams();
            params.append("cluster_id", this.clusterId);
            params.append("area_id", this.areaId);

            const request = {
                params: params,
                withCredentials: true
            };

            this.$axios
            .get(`/srv/api/system_diagram_setting`, request)
            .then(response => {
                if (typeof response.data == "object") {
                    console.log("[GET] [list system_diagram info]: OK");
                    this.systemDiagramInfoList = response.data.system_diagram_info;

                    if (this.systemDiagramInfoList && this.systemDiagramInfoList.length > 0) {
                        this.showRegisterModal = false
                        this.showSelectModal = true
                    } else {
                        this.showSelectModal = false
                        this.showRegisterModal = true
                    }
                } else {
                    // stringのときはセッションタイムアウト
                    alert("sesssion time out");
                    this.$store.dispatch("logout");
                    this.$router.push("/login");
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
        getSystemDiagramSettingsList:function() {
            this.$axios
            .get(`/srv/api/system_diagram_setting/settings/${this.systemDiagram.id}`, {
                withCredentials: true
            })
            .then(response => {
                
                if (typeof response.data == "object") {
                    console.log("[GET] [system_diagram_setting settings] : OK");
                    this.systemDiagramSettingsList = response.data.system_diagram_settings;
                    this.totalRecord = this.systemDiagramSettingsList.length
                } else {
                    // stringのときはセッションタイムアウト
                    alert("sesssion time out")
                    this.$store.dispatch("logout")
                    this.$router.push("/login")
                }
            })
            .catch(error => {
                console.log("system_diagram_setting settings error");
                console.log(error);
            });
        },
        onChangeDivision: function(event, rowIndex) {
            let divisionId = event.target.value ? parseInt(event.target.value) : ''
            let divi = this.systemDiagramDivision.get(divisionId)
            
            let fromPage = (this.currentPage * this.perPage) - this.perPage;
            let sysDiagram = this.systemDiagramSettingsList[rowIndex + fromPage]

            this.additionalSystemDiagramDivisionForObject(sysDiagram, divi)
        },
        additionalSystemDiagramDivisionForObject: function(object, divi) {
            object["item_status"] = divi["item_status"]
            object["division_status"] = divi["division_status"]
            object["data_status"] = divi["data_status"]
            object["on_icon_status"] = divi["on_icon_status"]
            object["on_icon_x_status"] = divi["on_icon_x_status"]
            object["on_icon_y_status"] = divi["on_icon_y_status"]
            object["off_icon_status"] = divi["off_icon_status"]
            object["off_icon_x_status"] = divi["off_icon_x_status"]
            object["off_icon_y_status"] = divi["off_icon_y_status"]
            object["text_status"] = divi["text_status"]
            object["font_size_status"] = divi["font_size_status"]
            object["font_color_status"] = divi["font_color_status"]
            object["font_style_status"] = divi["font_style_status"]
            object["coordinate_status"] = divi["coordinate_status"]
            object["layer_status"] = divi["layer_status"]
            return object
        },
        pageAndIndex: function(index) {
            return `${index}`
        },
        dumpData: function() {
            let arr = []
            for(let i = 1; i <= 500; i++) {
                arr.push({
                    "no": i,
                    "id": "",
                    "name": "",
                    "division_id": 0,
                    "division_name": "",
                    "data_id": "",
                    "on_icon": "",
                    "on_icon_x": "",
                    "on_icon_y": "",
                    "off_icon": "",
                    "text": "",
                    "font_size": 10,
                    "font_color": 1,
                    "font_style": 0,
                    "axis_x": 0,
                    "axis_y": 0,
                    "layer": 1,
                    "item_status": 0,
                    "division_status": 1,
                    "data_status": 0,
                    "on_icon_status": 0,
                    "on_icon_x_status": 0,
                    "on_icon_y_status": 0,
                    "off_icon_status": 0,
                    "off_icon_x_status": 0,
                    "off_icon_y_status": 0,
                    "text_status": 0,
                    "font_size_status": 0,
                    "font_color_status": 0,
                    "font_style_status": 0,
                    "coordinate_status": 0,
                    "layer_status": 0
                })
            }
            this.totalRecord = arr.length
            return arr
        }
    }
};
</script>
